import React, { useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';

const Login = ({onLogin}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate(); // Asegúrate de que esta línea esté aquí

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await api.post('/usuarios/login', { email, password });

        
        // Verificar la existencia del token
        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            // console.log('Token guardado:', response.data.token);
            onLogin({ token: response.data.token, usuario: response.data.usuario })  // Llama a la función onLogin con el usuario
           // Redireccionar según el rol
      if (response.data.usuario.role === 'USER') {
        navigate('/dashboard/rentas');
      } else {
        navigate('/dashboard');
      }
    } else {
      setErrorMessage('No se recibió un token. Verifica tus credenciales.');
    }
    } catch (err) {
        // Imprimir error para más información
        console.error('Error al iniciar sesión:', err);
        setErrorMessage('Error al iniciar sesión: ' + (err.response?.data?.message || err.message));
    }
}



const backgroundStyle = {};

  return (
    <section
      className="fixed inset-0 w-screen h-screen overflow-hidden bg-gradient-to-br from-blue-800 via-blue-900 to-blue-950"
      aria-label="Pantalla de inicio de sesión"
    >
      {/* Overlay subtle grid */}
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(rgba(255,255,255,0.12) 1px, transparent 1px)', backgroundSize: '24px 24px' }} />

      {/* Decorative blur orbs */}
      <div className="pointer-events-none absolute -top-20 -left-20 h-72 w-72 rounded-full bg-indigo-400/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-cyan-400/30 blur-3xl" />

      <div className="relative z-10 h-full w-full flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Brand header */}
          <div className="text-center mb-8">
            <h1 className="text-4xl font-black tracking-tight text-white drop-shadow-sm">
              Facturas<span className="text-blue-300">OH</span>
            </h1>
            <p className="mt-2 text-sm text-white/80">Accede a tu panel de gestión</p>
          </div>

          {/* Glass card */}
          <div className="group relative rounded-2xl border border-white/15 bg-white/10 backdrop-blur-xl shadow-[0_10px_30px_rgba(0,0,0,0.35)] overflow-hidden w-full">
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{
              background: 'radial-gradient(800px 200px at 50% -20%, rgba(255,255,255,0.12), transparent 60%)'
            }} />
            <div className="relative px-6 sm:px-8 py-8 sm:py-10">
              <h2 className="text-center text-2xl font-bold mb-6 text-white">Bienvenido</h2>
              {errorMessage && (
                <div role="alert" className="mb-5 rounded-lg border border-red-300/30 bg-red-50/70 px-4 py-3 text-red-700">
                  {errorMessage}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5">
                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-xs font-medium text-white/80 mb-1.5">Correo electrónico</label>
                  <div className="relative">
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="username"
                      className="w-full h-12 rounded-lg border border-white/20 bg-white/15 text-white placeholder-white/50 px-4 outline-none transition focus:border-cyan-300/70 focus:ring-2 focus:ring-cyan-300/30 backdrop-blur-md"
                      placeholder="tu@correo.com"
                      required
                      aria-invalid={!!errorMessage}
                    />
                  </div>
                </div>

                {/* Password */}
                <div>
                  <label htmlFor="password" className="block text-xs font-medium text-white/80 mb-1.5">Contraseña</label>
                  <div className="relative">
                    <input
                      id="password"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      className="w-full h-12 rounded-lg border border-white/20 bg-white/15 text-white placeholder-white/50 px-4 outline-none transition focus:border-cyan-300/70 focus:ring-2 focus:ring-cyan-300/30 backdrop-blur-md"
                      placeholder="••••••••"
                      required
                      aria-invalid={!!errorMessage}
                    />
                  </div>
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  className="relative inline-flex w-full items-center justify-center overflow-hidden rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-3 text-white font-semibold shadow-lg transition focus:outline-none focus:ring-2 focus:ring-blue-300/40 hover:from-blue-400 hover:to-blue-500"
                >
                  <span className="absolute inset-0 -translate-y-[120%] group-hover:translate-y-0 transition-transform duration-500 bg-white/10" />
                  <span className="relative">Ingresar</span>
                </button>

                {/* Meta */}
                <div className="flex items-center justify-between text-xs text-white/70">
                  <span>Protegido con JWT</span>
                  <span>© {new Date().getFullYear()} FacturasOH</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Login;
